import { createSelector } from 'reselect';
import DespatchParticularsContentColumns from '../../containers/DespatchParticularsContentColumns';
import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.DESPATCH_PARTICULARS_CONTENT.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.DESPATCH_PARTICULARS_CONTENT.isLoading;

export const getData = ReportsDefinition.DESPATCH_PARTICULARS_CONTENT.getDataFunction();

export const getColumns = createSelector(getData, DespatchParticularsContentColumns);
